import { graphql } from '@teachino/shared-infrastructure';
import type { ResultOf } from 'gql.tada';

export const itemFragment = graphql(`
  fragment LibraryItem on Material {
    __typename
    id
    name
    icon
    duration
    topic {
      id
      name
    }
  }
`);

type ItemFragment = ResultOf<typeof itemFragment>;

export type Item = ItemFragment;

export function convertItemFragment(item: ItemFragment): Item {
  return item;
}
